var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{ref:"button",staticClass:"action-button",attrs:{"variant":"link","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.value)?_c('ExistingCommentIcon',[_vm._v(_vm._s(_vm.value))]):_c('NewCommentIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }